import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { componentsReady, load } from "@porsche-design-system/components-js";
import "./mock/registerMockMode";
import AppLandScapeEnforcer from "Components/AppLandScapeEnforcer/AppLandScapeEnforcer";
import { AuthContextProvider } from "MainApp/assets/utils/context/AuthContext";
import { IsRotatedProvider } from "MainApp/assets/utils/context/isRotatedContext";
import App from "./App";
import i18n from "./i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

load();
componentsReady().then(() => {
  root.render(
    <Suspense fallback={<div>{i18n.t("common:loading")}</div>}>
      <React.StrictMode>
        <AuthContextProvider>
          <IsRotatedProvider>
            <AppLandScapeEnforcer>
              <App />
            </AppLandScapeEnforcer>
          </IsRotatedProvider>
        </AuthContextProvider>
      </React.StrictMode>
    </Suspense>
  );
});

reportWebVitals();
